var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.064,
    height: 16.663,
    viewBox: "0 0 10.064 16.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-female",
    "data-name": "Icon metro-female",
    d: "M16.294,14.225V16.2h2.391v2.391H16.294v2.391H13.866V18.587H11.475V16.2h2.391V14.218a4.762,4.762,0,1,1,2.428.007Zm-1.22-7.019A2.39,2.39,0,1,0,17.465,9.6,2.391,2.391,0,0,0,15.074,7.206Z",
    transform: "translate(-10.042 -4.565)",
    fill: "#ff52c5",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.700a5a606b635c83e663a09f88dfab22.svg";
export { ForwardRef as ReactComponent };